import styled from 'styled-components'

export const ContentAccessButtonContainer = styled.button`
  display: block;
  margin: 2rem auto 0 auto;
`
